import {z} from 'zod'

const spacingSchema = z.object({
  type: z.literal('loadSpace'),
  loadSpace: z.number(),
  loadSpaceUom: z.string()
})
const flowRateSchema = z.object({
  type: z.literal('flowRate'),
  flowRate: z.number(),
  flowRateUom: z.string()
})
const spacingOrFlowRateSchema = z.union([spacingSchema, flowRateSchema])
const timeOnJobSiteSchema = z.object({
  time: z.number(),
  timeUom: z.string()
})

export const loadSpacingSchema = z.object({
  spacingOrFlowRate: z.union([spacingOrFlowRateSchema, z.undefined()]),
  timeOnJobSite: z.union([timeOnJobSiteSchema, z.undefined()])
})
